import { BugReport } from '@mui/icons-material'
import { TeamManagementPanel } from './TeamManagementPanel'
import { useAdventureEditorStore } from '../../../stores/adventureEditorStore'

export function TeamPanel() {
  const adventureId = useAdventureEditorStore((state) => state.adventureId)

  return (
    <TeamManagementPanel
      adventureId={adventureId}
      roleType="Tester"
      title="Adventure Testers"
      description="Testers can test the adventure before publication"
      icon={<BugReport />}
    />
  )
}
